/* Decades — route every cart link to the Atlas cart drawer.
 *
 * The header cart icon (and any other theme link to /cart) is a plain anchor;
 * the Atlas cart-upsells app embed intercepts those clicks once its CDN bundle
 * has loaded. Before that, a click would fall through and navigate to the
 * legacy /cart page. This script blocks that navigation entirely: links to
 * /cart never navigate — they only ever open the Atlas drawer. If the bundle
 * hasn't loaded yet, the click is queued and replayed as soon as the drawer
 * exists in the DOM.
 */
(function () {
  'use strict';

  var DRAWER_ID = 'atlas-upsell-cart-drawer-main-container';
  var RETRY_MS = 150;
  var MAX_WAIT_MS = 10000;

  function drawerReady() {
    return !!document.getElementById(DRAWER_ID);
  }

  // Returns the anchor if (and only if) it points at the cart page itself.
  // /cart/add, /cart/change etc. are left alone.
  function cartLink(target) {
    var a = target && target.closest && target.closest('a[href]');
    if (!a) return null;
    var path;
    try {
      path = new URL(a.getAttribute('href'), location.origin).pathname.replace(/\/+$/, '');
    } catch (e) {
      return null;
    }
    return path === '/cart' ? a : null;
  }

  var waiting = false;

  function replayWhenReady(link) {
    if (waiting) return;
    waiting = true;
    var started = Date.now();
    (function poll() {
      if (drawerReady()) {
        waiting = false;
        link.click(); // Atlas's own listener opens the drawer
        return;
      }
      if (Date.now() - started > MAX_WAIT_MS) {
        waiting = false;
        return;
      }
      setTimeout(poll, RETRY_MS);
    })();
  }

  document.addEventListener('click', function (e) {
    var link = cartLink(e.target);
    if (!link) return;
    e.preventDefault(); // never navigate to /cart
    if (!drawerReady()) replayWhenReady(link);
    // When the drawer exists, Atlas's bubble-phase listener opens it.
  }, true);
})();
